import React from 'react';

import './message.css';

interface Props {
  notification?: {
    image?: string;
    title?: string;
    body?: string;
  };
}

const Message = ({ notification }: Props) => {
  return (
    <>
      <div id="notificationHeader">
        {notification?.image && (
          <div id="imageContainer">
            <img src={notification.image} width={100} alt="" />
          </div>
        )}
        <span>{notification?.title}</span>
      </div>
      <div id="notificationBody">{notification?.body}</div>
    </>
  );
};

export default Message;
